export default "__VITE_ASSET__db8e948c__"